export const medications = [

  /*
    AINES
  */

  {
    id: 1,
    name: "Ibuprofeno",
    category: "AINE",

    pediatricPresentation:
      "100mg/5mL",

    adultPresentation:
      "Tabletas 600mg",

    pediatricDose: {
      calculation: "mg/kg/dose",
      minAgeMonths: 6,
      doseMinMgKg: 4,
      doseMaxMgKg: 10,
      maxSingleDoseMg: 600,
      interval: "6-8h",
      maxDailyMgKg: 40
    },

    adultDose:
      "1 tableta cada 8h",

    interval: "8h",

    duration: 3,

    route: "VO",

    warnings: [
      "hipertension"
    ],

    contraindications: [
      "anticoagulantes"
    ],

    allowedRoutes: [
      "VO"
    ]
  },

  {
    id: 2,
    name: "Ketorolaco",
    category: "AINE",

    pediatricPresentation:
      null,

    pediatricDose: {
      calculation: "manual",
      autoCalculate: false,
      requiresClinicalReview: true,
      note: "No automatizar: requiere valoración clínica pediátrica y formulación/indicación específica."
    },

    adultPresentation:
      "Tabletas 10mg",

    adultDose:
      "1 tableta cada 8h",

    interval: "8h",

    duration: 3,

    route: "VO"
  },

  {
    id: 3,
    name: "Paracetamol",
    category: "AINE",

    pediatricPresentation:
      "250mg/5mL",

    adultPresentation:
      "Tabletas 500mg",

    pediatricDose: {
      calculation: "mg/kg/dose",
      minAgeMonths: 3,
      doseMinMgKg: 10,
      doseMaxMgKg: 15,
      interval: "4-6h",
      maxDailyMgKg: 75,
      maxDailyDoseMg: 4000
    },

    adultDose:
      "1 tableta cada 8h",

    interval: "8h",

    duration: 3,

    route: "VO"
  },

  /*
    ANTIBIÓTICOS
  */

  {
    id: 4,
    name: "Amoxicilina",
    category: "Antibiótico",

    pediatricPresentation:
      "250mg/5mL",

    adultPresentation:
      "Cápsulas 500mg",

    pediatricDose: {
      calculation: "mg/kg/day",
      minAgeMonths: 3,
      doseMinMgKgDay: 20,
      doseMaxMgKgDay: 40,
      interval: "8h",
      maxSingleDoseMg: 500
    },

    adultDose:
      "1 cápsula cada 8h",

    interval: "8h",

    duration: 7,

    route: "VO",

    allergyContraindications: [
      "Penicilina"
    ],

    allowedRoutes: [
      "VO"
    ]
  },

  {
    id: 5,
    name:
      "Amoxicilina + Ácido clavulánico",

    category: "Antibiótico",

    pediatricPresentation:
      "400mg/57mg/5mL",

    adultPresentation:
      "Tabletas 500mg/125mg",

    pediatricDose: {
      calculation: "mg/kg/day",
      minAgeMonths: 3,
      doseMinMgKgDay: 25,
      doseMaxMgKgDay: 45,
      interval: "12h",
      maxSingleDoseMg: 875,
      maxDailyDoseMg: 1750,
      basedOnComponent: "amoxicilina"
    },

    adultDose:
      "1 tableta cada 12h",

    interval: "12h",

    duration: 7,

    route: "VO",

    allergyContraindications: [
      "Penicilina"
    ]
  },

  {
    id: 6,
    name: "Clindamicina",
    category: "Antibiótico",

    pediatricPresentation:
      "75mg/5mL",

    adultPresentation:
      "Cápsulas 300mg",

    pediatricDose: {
      calculation: "mg/kg/day",
      doseMinMgKgDay: 20,
      doseMaxMgKgDay: 30,
      interval: "8h",
      maxSingleDoseMg: 450
    },

    adultDose:
      "1 cápsula cada 8h",

    interval: "8h",

    duration: 7,

    route: "VO",

    allowedRoutes: [
      "VO"
    ]
  },

  {
    id: 7,
    name: "Azitromicina",
    category: "Antibiótico",

    pediatricPresentation:
      "200mg/5mL",

    adultPresentation:
      "Tabletas 500mg",

    pediatricDose: {
      calculation: "mg/kg/dose",
      doseMinMgKg: 10,
      doseMaxMgKg: 12,
      day1: true,
      maintenanceDoseMinMgKg: 5,
      maintenanceDoseMaxMgKg: 6,
      interval: "24h",
      maxSingleDoseMg: 500,
      durationDaysMin: 2,
      durationDaysMax: 5
    },

    adultDose:
      "1 tableta cada 24h",

    interval: "24h",

    duration: 3,

    route: "VO",

    allowedRoutes: [
      "VO"
    ]
  },

  /*
    CORTICOIDES
  */

  {
    id: 8,
    name: "Dexametasona",

    category:
      "Corticoesteroide",

    pediatricPresentation:
      null,

    pediatricDose: {
      calculation: "manual",
      autoCalculate: false,
      requiresClinicalReview: true,
      note: "No automatizar: la dosis pediátrica depende de indicación, vía y contexto clínico."
    },

    adultPresentation:
      "8mg/2mL",

    adultDose:
      "1 ampolleta IM dosis única",

    interval: "Única",

    duration: 1,

    route: "IM",

    warnings: [
      "diabetes",
      "hipertension"
    ],

    allowedRoutes: [
      "IM",
      "IV"
    ]
  },

  {
    id: 9,
    name: "Naproxeno",

    category: "AINE",

    pediatricPresentation:
      "Suspensión",

    pediatricDose: {
      calculation: "mg/kg/dose",
      doseMinMgKg: 5,
      doseMaxMgKg: 7,
      interval: "8-12h",
      maxDailyDoseMg: 1000
    },

    adultPresentation:
      "Tabletas 550mg",

    adultDose:
      "1 tableta cada 12h",

    interval: "12h",

    duration: 5,

    route: "VO",

    warnings: [
      "hipertension"
    ],

    contraindications: [
      "anticoagulantes"
    ]
  },

  {
    id: 10,
    name: "Diclofenaco",

    category: "AINE",

    pediatricDose: {
      calculation: "manual",
      autoCalculate: false,
      requiresClinicalReview: true,
      note: "No automatizar: requiere valoración pediátrica e indicación específica."
    },

    adultPresentation:
      "Tabletas 50mg",

    adultDose:
      "1 tableta cada 8h",

    interval: "8h",

    duration: 5,

    route: "VO",

    warnings: [
      "hipertension"
    ],

    contraindications: [
      "anticoagulantes"
    ]
  },

  {
    id: 11,
    name: "Metamizol",

    category: "Analgésico",

    pediatricDose: {
      calculation: "manual",
      autoCalculate: false,
      requiresClinicalReview: true,
      note: "No automatizar: requiere protocolo pediátrico específico y presentación disponible."
    },

    adultPresentation:
      "Tabletas 500mg",

    adultDose:
      "1 tableta cada 8h",

    interval: "8h",

    duration: 3,

    route: "VO"
  },

  {
    id: 12,
    name: "Tramadol",

    category: "Analgésico",

    pediatricDose: {
      calculation: "manual",
      autoCalculate: false,
      requiresClinicalReview: true,
      note: "No recomendado como analgésico pediátrico de primera línea; requiere valoración clínica especializada."
    },

    adultPresentation:
      "Cápsulas 50mg",

    adultDose:
      "1 cápsula cada 8h",

    interval: "8h",

    duration: 3,

    route: "VO",

    warnings: [
      "epilepsia"
    ]
  },

  {
    id: 13,
    name: "Betametasona",

    category: "Corticoide",

    pediatricDose: {
      calculation: "manual",
      autoCalculate: false,
      requiresClinicalReview: true,
      note: "No automatizar: la dosis pediátrica depende de indicación, vía y contexto clínico."
    },

    adultPresentation:
      "Ampolleta 8mg",

    adultDose:
      "1 ampolleta IM dosis única",

    interval: "Única",

    duration: 1,

    route: "IM",

    warnings: [
      "diabetes",
      "hipertension"
    ],

    allowedRoutes: [
      "IM",
      "IV"
    ]
  },

  {
    id: 14,
    name: "Clorhexidina 0.12%",

    category: "Antiséptico",

    adultPresentation:
      "Enjuague 250mL",

    pediatricDose: {
      calculation: "fixed",
      minAgeYears: 8,
      dose: "15mL",
      interval: "12h",
      duration: 7,
      instructions:
        "Enjuagar 30 segundos y escupir; usar solución sin alcohol en niños con riesgo de ingestión"
    },

    adultDose:
      "15mL",

    interval: "12h",

    duration: 7,

    route: "ENJUAGUE",

    customAdministration:
      "enjuague",

    allowedRoutes: [
      "ENJUAGUE"
    ]
  },

  /*
    ANTIBIÓTICOS ADICIONALES
  */

  {
    id: 15,
    name: "Metronidazol",

    category: "Antibiótico",

    pediatricPresentation:
      "125mg/5mL",

    adultPresentation:
      "Tabletas 500mg",

    pediatricDose: {
      calculation: "mg/kg/dose",
      indication: "periodontal",
      doseMgKg: 10,
      interval: "8h",
      duration: 7,
      maxSingleDoseMg: 250
    },

    adultDose:
      "1 tableta cada 8h",

    interval: "8h",

    duration: 7,

    route: "VO",

    allowedRoutes: [
      "VO"
    ]
  },

  {
    id: 16,
    name: "Cefalexina",

    category: "Antibiótico",

    pediatricPresentation:
      "250mg/5mL",

    adultPresentation:
      "Cápsulas 500mg",

    pediatricDose: {
      calculation: "mg/kg/day",
      doseMinMgKgDay: 25,
      doseMaxMgKgDay: 50,
      interval: "6-12h",
      maxDailyDoseMg: 2000,
      severeDoseMinMgKgDay: 75,
      severeDoseMaxMgKgDay: 100,
      severeInterval: "6-8h",
      severeMaxDailyDoseMg: 4000
    },

    adultDose:
      "1 cápsula cada 8h",

    interval: "8h",

    duration: 7,

    route: "VO"
  },

  {
    id: 17,
    name: "Claritromicina",

    category: "Antibiótico",

    pediatricPresentation:
      "250mg/5mL",

    adultPresentation:
      "Tabletas 500mg",

    pediatricDose: {
      calculation: "mg/kg/dose",
      doseMgKg: 7.5,
      interval: "12h",
      maxSingleDoseMg: 500
    },

    adultDose:
      "1 tableta cada 12h",

    interval: "12h",

    duration: 7,

    route: "VO"
  },

  /*
    ANTIFÚNGICOS
  */

  {
    id: 18,
    name: "Nistatina",

    category: "Antifúngico",

    pediatricPresentation:
      "100000 UI/mL",

    pediatricDose: {
      calculation: "fixed",
      infantDoseUnits: 200000,
      infantDoseMl: 2,
      infantInterval: "6h",
      childDoseUnitsMin: 400000,
      childDoseUnitsMax: 600000,
      childDoseMlMin: 4,
      childDoseMlMax: 6,
      childInterval: "6h",
      durationDaysMin: 7,
      durationDaysMax: 14
    },

    adultPresentation:
      "Suspensión oral",

    pediatricFixedDose: true,

    adultDose:
      "5mL",

    interval: "6h",

    duration: 14,

    route: "TOPICO"
  },

  {
    id: 19,
    name: "Fluconazol",

    category: "Antifúngico",

    pediatricPresentation:
      "Suspensión",

    pediatricDose: {
      calculation: "mg/kg/dose",
      doseMinMgKg: 6,
      doseMaxMgKg: 12,
      interval: "24h",
      durationDaysMin: 7,
      durationDaysMax: 14,
      maxSingleDoseMg: 400,
      indication: "candidiasis orofaríngea"
    },

    adultPresentation:
      "Tabletas 150mg",

    adultDose:
      "1 tableta cada 24h",

    interval: "24h",

    duration: 7,

    route: "VO"
  },

  /*
    ANTIVIRALES
  */

  {
    id: 20,
    name: "Aciclovir",

    category: "Antiviral",

    pediatricPresentation:
      "200mg/5mL",

    adultPresentation:
      "Tabletas 400mg",

    pediatricDose: {
      calculation: "mg/kg/dose",
      doseMgKg: 20,
      interval: "6h",
      durationDaysMin: 5,
      durationDaysMax: 7,
      maxSingleDoseMg: 800,
      indication: "gingivoestomatitis herpética primaria"
    },

    adultDose:
      "1 tableta cada 8h",

    interval: "8h",

    duration: 5,

    route: "VO"
  },

  /*
    ANSIOLÍTICOS
  */

  {
    id: 21,
    name: "Diazepam",

    category: "Ansiolítico",

    pediatricDose: {
      calculation: "manual",
      autoCalculate: false,
      requiresClinicalReview: true,
      note: "No automatizar: sedación pediátrica requiere protocolo específico, peso, indicación y monitorización."
    },

    adultPresentation:
      "Tabletas 5mg",

    pediatricFixedDose: true,

    adultDose:
      "1 tableta la noche previa",

    interval: "Única",

    duration: 1,

    route: "VO"
  },

  {
    id: 22,
    name: "Lorazepam",

    category: "Ansiolítico",

    pediatricDose: {
      calculation: "manual",
      autoCalculate: false,
      requiresClinicalReview: true,
      note: "No automatizar: sedación pediátrica requiere protocolo específico, peso, indicación y monitorización."
    },

    adultPresentation:
      "Tabletas 1mg",

    pediatricFixedDose: true,

    adultDose:
      "1 tableta 1h antes del procedimiento",

    interval: "Única",

    duration: 1,

    route: "VO"
  },

  /*
    PROTECTORES GÁSTRICOS
  */

  {
    id: 23,
    name: "Omeprazol",

    category: "Protector gástrico",

    pediatricDose: {
      calculation: "manual",
      autoCalculate: false,
      requiresClinicalReview: true,
      note: "No automatizar: la dosis pediátrica depende de edad, peso e indicación."
    },

    adultPresentation:
      "Cápsulas 20mg",

    adultDose:
      "1 cápsula cada 24h",

    interval: "24h",

    duration: 7,

    route: "VO",

    allowedRoutes: [
      "VO"
    ]
  },

  {
    id: 24,
    name: "Pantoprazol",

    category: "Protector gástrico",

    pediatricDose: {
      calculation: "manual",
      autoCalculate: false,
      requiresClinicalReview: true,
      note: "No automatizar: la dosis pediátrica depende de edad, peso e indicación."
    },

    adultPresentation:
      "Tabletas 40mg",

    adultDose:
      "1 tableta cada 24h",

    interval: "24h",

    duration: 7,

    route: "VO"
  },

  /*
    EMERGENCIAS
  */

  {
    id: 25,
    name: "Epinefrina",

    category: "Emergencia",

    pediatricDose: {
      calculation: "manual",
      autoCalculate: false,
      requiresClinicalReview: true,
      note: "No automatizar: la dosis depende de la indicación y del protocolo de emergencia."
    },

    adultPresentation:
      "1mg/mL",

    pediatricFixedDose: true,

    adultDose:
      "0.3mg IM",

    interval: "Única",

    duration: 1,

    route: "IM",

    warnings: [
      "hipertension",
      "cardiopatias"
    ],

    allowedRoutes: [
      "IM",
      "IV"
    ]
  },

  {
    id: 26,
    name: "Glucosa Oral",

    category: "Emergencia",

    pediatricDose: {
      calculation: "manual",
      autoCalculate: false,
      requiresClinicalReview: true,
      note: "No automatizar: la dosis depende de peso, glucemia, estado clínico y protocolo de hipoglucemia."
    },

    adultPresentation:
      "Gel Oral",

    pediatricFixedDose: true,

    adultDose:
      "15g",

    interval: "Única",

    duration: 1,

    route: "VO"
  },

  /*
    PROFILAXIS
  */

  {
    id: 27,
    name: "Amoxicilina Profilaxis",

    category: "Profilaxis",

    pediatricDose: {
      calculation: "mg/kg/dose",
      doseMgKg: 50,
      maxSingleDoseMg: 2000,
      interval: "Única",
      timing: "30-60min antes del procedimiento",
      autoCalculate: true
    },

    adultPresentation:
      "Tabletas 500mg",

    pediatricFixedDose: true,

    adultDose:
      "4 tabletas 1h antes",

    interval: "Única",

    duration: 1,

    route: "VO"
  },

  {
    id: 28,
    name: "Clindamicina Profilaxis",

    category: "Profilaxis",

    pediatricDose: {
      calculation: "not-recommended",
      autoCalculate: false,
      note: "AAPD 2025-2026 ya no recomienda clindamicina para profilaxis de endocarditis en procedimientos dentales."
    },

    adultPresentation:
      "Cápsulas 300mg",

    pediatricFixedDose: true,

    adultDose:
      "2 cápsulas 1h antes",

    interval: "Única",

    duration: 1,

    route: "VO"
  }

];